<script setup lang="ts">
import { useI18nStore } from '@99fun-agent/stores';
import { computed } from 'vue'


/**
 * 语言选择器组件
 * 可用于登录页、设置下拉菜单等场景
 */

const props = withDefaults(
  defineProps<{
    /** 显示模式 */
    mode?: 'dropdown' | 'list'
    /** 是否显示本地名称 */
    showNativeName?: boolean
    /** 列表项的 CSS 类名 */
    itemClass?: string
    /** 选中项的 CSS 类名 */
    selectedItemClass?: string
    /** 容器的 CSS 类名 */
    containerClass?: string
  }>(),
  {
    mode: 'list',
    showNativeName: true,
    itemClass: '',
    selectedItemClass: '',
    containerClass: ''
  }
)

const emit = defineEmits<{
  select: [langCode: string]
}>()

const i18nStore = useI18nStore()

// 选择语言
const selectLanguage = async (langCode: string) => {
  // 触发事件，让父组件处理语言切换
  i18nStore.setAppLang(langCode)
  emit('select', langCode)
}
</script>

<template>
  <div :class="containerClass">
    <div
      v-for="lang in i18nStore.supportLanguageList"
      :key="lang.key"
      class="language-item"
      :class="[
        itemClass,
        i18nStore.appLang === lang.key && selectedItemClass
      ]"
      @click="selectLanguage(lang.key)"
    >
      <slot name="item" :lang="lang " :isSelected="i18nStore.appLang === lang.key">
        <!-- 默认插槽内容 -->
        <div class="flex items-center justify-between gap-2 w-full">
          <span class="language-name">
            {{ lang.name }}
          </span>
          <span
            v-if="showNativeName"
            class="language-native-name"
          >
            {{ lang.nativeName }}
          </span>
        </div>
      </slot>
    </div>
  </div>
</template>

<style scoped>
.language-item {
  cursor: pointer;
  transition: all 0.2s ease;
}

.language-name {
  font-size: 14px;
  font-weight: 500;
}

.language-native-name {
  font-size: 11px;
  opacity: 0.7;
  white-space: nowrap;
  margin-left: auto;
}
</style>
